module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("akuxC"))).then(() => parcelRequire('g8hgl'));